import { TenantService } from 'src/app/tenants/services/tenant.service';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  CoreActionsTypes,
  InitEmbeddedApp,
  InitEmbeddedAppError,
  InitEmbeddedAppSuccess,
} from './core.actions';
import {
  catchError,
  delay,
  filter,
  switchMap,
  take,
  tap,
} from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { forkJoin, of } from 'rxjs';
import {
  AuthActionsTypes,
  TenantsRolesLoaded,
  TokenUpdate,
} from 'src/app/auth/store/auth.actions';
import { tokenSelector } from 'src/app/auth/store/auth.selectors';
import { TenantsLoaded } from '../../tenants/store/tenant.actions';

@Injectable()
export class CoreEffects {
  protected readonly actions$ = inject(Actions);
  protected readonly store = inject(Store<AppState>);
  protected readonly tenantService = inject(TenantService);

  initEmbeddedApp$ = createEffect(() =>
    this.actions$.pipe(
      ofType<InitEmbeddedApp>(CoreActionsTypes.InitEmbeddedApp),
      switchMap(() => {
        if (window.self !== window.top) {
          this.store.dispatch(new InitEmbeddedAppSuccess({ embebApp: true }));
        }
        return of(new InitEmbeddedAppError());
      })
    )
  );

  // NOTE Important: Load tenants when token is received in iframe mode

  loadTenantsOnTokenUpdate$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<TokenUpdate>(AuthActionsTypes.TokenUpdate),
        filter(() => window.self !== window.top),
        delay(1000),
        switchMap(() =>
          this.store.select(tokenSelector).pipe(
            filter(token => !!token && token.length > 0),
            take(1),
            switchMap(() => {
              // Cargar tenants y roles en paralelo
              return forkJoin([
                //this.tenantService.getTenants(),
                this.tenantService.getTenantCustomRoles(),
              ]).pipe(
                //tap(([tenants, tenantRoles]) => {
                tap(([tenantRoles]) => {
                  /*
                  if (!!tenants && tenants?.length > 0) {
                    this.store.dispatch(new TenantsLoaded({ tenants }));
                  }
                    */

                  this.store.dispatch(new TenantsRolesLoaded({ tenantRoles }));
                }),
                catchError(() => of([]))
              );
            })
          )
        )
      ),
    { dispatch: false }
  );
}
